export default __webpack_public_path__ + "static/media/sell-courses.86a33b49.svg";